<template>
    <div>
        <p class="p-executive-dashboard__summary">
            Our Executive Dashboard provides a snapshot of key quantum and reserving data on your book of business.<br><br>
            You can drill down into your live and concluded claims data.
        </p>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'page-header',
        components: {
        },
        computed: {
        },
        methods: {
        },
    }
</script>



// WEBPACK FOOTER //
// PageHeader.vue?5fecb577